import React, { memo, Fragment, useMemo } from 'react';
import { array } from 'prop-types';
import classNames from 'classnames/bind';

import { VALEO_BRANDS } from 'utils/constantsHelper';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import styles from './ResultsList.module.scss';
import SearchItem from '../SearchItem/SearchItem';
const cx = classNames.bind(styles);

const ResultsList = ({ data }) => {
  const sortedList = useMemo(() => {
    let list = [...data];
    list.sort((a, b) => {
      const { brandNo: aBrandNo } = a.directArticle || a.assignedArticle || {};
      const { brandNo: bBrandNo } = b.directArticle || b.assignedArticle || {};
      const isAValeoBrand = VALEO_BRANDS.includes(aBrandNo);
      const isBValeoBrand = VALEO_BRANDS.includes(bBrandNo);
      if (isAValeoBrand === isBValeoBrand) return 0;
      return isAValeoBrand ? -1 : 1;
    });
    return list;
  }, [data]);

  return (
    <Fragment>
      {sortedList.map((item, index) => (
        <div className={cx('item')} key={index}>
          <SearchItem data={item} />
        </div>
      ))}
    </Fragment>
  );
};

ResultsList.propTypes = {
  data: array.isRequired,
};

export default memo(withErrorBoundary(ResultsList));



// WEBPACK FOOTER //
// ./src/components/ResultsList/ResultsList.js